import { SET_VIEWCATEGORYLIST } from '../actions';

const categorylistview = (state = [], action) => {
  switch (action.type) {
	case SET_VIEWCATEGORYLIST:
      return [...action.value];  
    default: return state;
  }
}

export default categorylistview;
